// import moment from "moment";
import React, { Component } from "react";
import LoadingPage from "@components/Loading/Loading";
import TableServiceCenter from "@components/Table/TableServiceCenter";
import config from "@config";
import apiEndpoints from "@store/apiEndpoints";
import utilityFunctions, { isSuperAdminRole } from "@store/utilityFunctions";
import errorFunctions from "@store/errorFunctions";
import "../common.css";
import "./ServiceCenterList.css";
// import { IoMdAddCircle } from "react-icons/io";
import { MdClose } from "react-icons/md";
import Modal from "react-modal";
import ServiceCenterAdd from "./ServiceCenterAdd";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Select from "react-select";
import TablePagination from "@mui/material/TablePagination";

const countryOptions = [
  { value: "AU", label: "Australia" },
  { value: "NZ", label: "New Zealand" },
];

const statusFlowOptions = [
  { value: "upload_pdf", label: "Upload PDF" },
  { value: "send_link", label: "Send Link" },
];

export default class ServiceCenterList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      serviceCenters: [],
      serviceCenterCentrals: [],
      serviceCenterCentral: "",
      serviceCenterCentralId: 0,
      serviceCenterCentralName: "",
      serviceCenterCentralBrandId: "",
      serviceCenterName: "",
      searchFilter: "",
      searchInput: "",
      openServiceCenterCentralAdd: false,
      showDeleteModal: false,
      openServiceCenterAdd: false,
      isAdd: false,
      // Pagination state for locations
      page: 1,
      limit: 10,
      totalCount: 0,
      // Pagination state for service center centrals
      centralPage: 1,
      centralLimit: 50,
      centralTotalCount: 0,
    };
  }

  componentDidMount() {
    this.retrieveServiceCenterCentral();
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedbrandID !== prevProps.selectedbrandID) {
      this.retrieveServiceCenterCentral();
    }
  }

  retrieveServiceCenter = (id) => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        apiEndpoints.serviceCenterCentral.detail(id),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({
          loading: false,
          serviceCenters: res.service_centers,
          statusFlow: res.status_flow,
          returnLabelLink: res.return_label_link,
          brand: this.props.selectedbrandID,
        });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  retrieveServiceCenterLocation = (id) => {
    this.setState({ loading: true });
    const { page, limit, searchFilter } = this.state;

    let params = {
      page: page,
      limit: limit,
    };
    if (searchFilter) {
      params.q = searchFilter;
    }

    this.props
      .protectedFetch(
        apiEndpoints.serviceCenterCentral.location(id),
        "GET",
        params,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({
          loading: false,
          serviceCenters: res.results || res.data || res,
          totalCount:
            res.total_count ||
            res.count ||
            (res.results ? res.results.length : res.length),
        });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  retrieveServiceCenterCentral = () => {
    const userBrands = this.props.userInfo?.user?.brands || [];
    const country = config.country;

    // Filter brands by country if country exists
    const filteredBrands =
      country && !isSuperAdminRole(this.props.userInfo?.user?.email)
        ? userBrands.filter((brand) => brand.country === country)
        : userBrands;

    // Get all brand IDs
    const brandIds = filteredBrands.map((brand) => brand.id).join(",");

    this.setState({ loading: true });
    const { centralPage, centralLimit } = this.state;

    // Build query string manually to preserve commas in brandId
    let queryParams = [];
    queryParams.push(`page=${centralPage}`);
    queryParams.push(`limit=${centralLimit}`);

    if (this.props.selectedbrandID) {
      queryParams.push(`brandId=${this.props.selectedbrandID}`);
    } else if (brandIds) {
      queryParams.push(`brandId=${brandIds}`);
    }

    if (this.props.userInfo.user.role !== "Admin") {
      queryParams.push(`country=${config.country}`);
    }

    const queryString = queryParams.join("&");

    this.props
      .protectedFetch(
        apiEndpoints.serviceCenterCentral.list(queryString),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        const results = res.results || res.data || res;
        const totalCount =
          res.total_count || res.count || (Array.isArray(res) ? res.length : 0);

        this.setState({
          loading: false,
          serviceCenterCentrals: results,
          centralTotalCount: totalCount,
        });

        // Only auto-select if we have results and no current selection
        if (results.length > 0 && !this.state.serviceCenterCentralId) {
          this.setState({
            serviceCenterCentral: results[0],
            serviceCenterCentralId: results[0].id,
          });
          this.retrieveServiceCenterLocation(results[0].id);
        }
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  getBrandIdForCountry = (country) => {
    const userBrands =
      this.props.userInfo?.user?.brands || this.props.userInfo?.brands || [];
    if (!country) return this.props.selectedbrandID || "";
    const matchedBrand = userBrands.filter(
      (brand) => brand.country === country,
    );

    return (
      matchedBrand.map((brand) => brand.id) || [this.props.selectedbrandID] ||
      null
    );
  };

  addServiceCenterCentral = () => {
    this.setState({ loading: true });
    const brandId = this.getBrandIdForCountry(this.state.country);
    const payload = {
      name: this.state.serviceCenterCentralName,
      country: this.state.country,
      status_flow: this.state.statusFlow,
      send_link: this.state.returnLabelLink,
      brand: brandId,
    };
    this.props
      .protectedFetch(
        apiEndpoints.serviceCenterCentral.create(),
        "POST",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        //do not show email with @treeclouds.com and @karadigital.co
        this.setState({
          loading: false,
          country: "",
          // serviceCenterCentrals: res,
          serviceCenterCentralId: 0,
          serviceCenterCentralName: "",
          openServiceCenterCentralAdd: false,
          isAdd: false,
        });
        this.retrieveServiceCenterCentral();
        // this.retrieveServiceCenter(res[0].id);
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };
  updateServiceCenterCentral = () => {
    this.setState({ loading: true });
    const brandId = this.getBrandIdForCountry(this.state.country);
    const payload = {
      name: this.state.serviceCenterCentralName,
      country: this.state.country,
      status_flow: this.state.statusFlow,
      return_label_link: this.state.returnLabelLink,
      brand: brandId,
    };
    this.props
      .protectedFetch(
        apiEndpoints.serviceCenterCentral.detail(
          this.state.serviceCenterCentralId,
        ) + "/",
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        //do not show email with @treeclouds.com and @karadigital.co
        this.setState({
          loading: false,
          country: "",
          // serviceCenterCentrals: res,
          openServiceCenterCentralAdd: false,
          serviceCenterCentralId: 0,
          isAdd: false,
          // serviceCenterCentralName: "",
        });
        this.retrieveServiceCenterCentral();
        // this.retrieveServiceCenter(res[0].id);
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  deleteServiceCenterCentral = async () => {
    this.setState({ loading: true });
    const token = utilityFunctions.getAccessToken();
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    fetch(
      apiEndpoints.serviceCenterCentral.detail(
        this.state.serviceCenterCentralId,
      ) + "/",
      options,
    )
      .then(async (resp) => {
        if (resp.status === 406) {
          const errorMsg = await resp.json();
          alert(errorMsg.message);
        } else if (resp.status === 204) alert("Delete success");
        //do not show email with @treeclouds.com and @karadigital.co
        this.setState({ loading: false, showDeleteModal: false });
        this.retrieveServiceCenterCentral();
        // this.retrieveServiceCenter(res[0].id);
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  };

  filterChange = (e) => {
    if (e.target.value.startsWith(" ")) return;
    this.setState({ searchInput: e.target.value });
  };

  handleSearchClick = () => {
    this.setState({ searchFilter: this.state.searchInput, page: 1 }, () => {
      if (this.state.serviceCenterCentralId) {
        this.retrieveServiceCenterLocation(this.state.serviceCenterCentralId);
      }
    });
  };

  handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSearchClick();
    }
  };

  handleClearSearch = () => {
    this.setState({ searchInput: "", searchFilter: "", page: 1 }, () => {
      if (this.state.serviceCenterCentralId) {
        this.retrieveServiceCenterLocation(this.state.serviceCenterCentralId);
      }
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleAddServiceCenter = () => {
    this.setState({ openServiceCenterAdd: true });
  };

  handleEditServiceCenterCentralClick = (sc) => {
    const brandId = this.getBrandIdForCountry(sc.country);
    this.setState({
      serviceCenterCentralId: sc.id,
      serviceCenterCentralName: sc.name,
      openServiceCenterCentralAdd: true,
      country: sc.country,
      returnLabelLink: sc.return_label_link,
      statusFlow: sc.status_flow,
      serviceCenterCentralBrandId: brandId,
      isAdd: false,
    });
    // Retrieve service center data for editing
    this.retrieveServiceCenter(sc.id);
  };

  handlePageChange = (newPage) => {
    this.setState({ page: newPage }, () => {
      if (this.state.serviceCenterCentralId) {
        this.retrieveServiceCenterLocation(this.state.serviceCenterCentralId);
      }
    });
  };

  handleLimitChange = (newLimit) => {
    this.setState({ limit: newLimit, page: 1 }, () => {
      if (this.state.serviceCenterCentralId) {
        this.retrieveServiceCenterLocation(this.state.serviceCenterCentralId);
      }
    });
  };

  handleCentralPageChange = (event, newPage) => {
    this.setState({ centralPage: newPage + 1 }, () => {
      this.retrieveServiceCenterCentral();
    });
  };

  handleCentralLimitChange = (event) => {
    this.setState(
      {
        centralLimit: parseInt(event.target.value, 10),
        centralPage: 1,
      },
      () => {
        this.retrieveServiceCenterCentral();
      },
    );
  };

  handleSellerClick = (id) => {
    this.setState({
      serviceCenterCentralId: id,
      page: 1,
      searchFilter: "",
      searchInput: "",
    });
    // Retrieve location details for display
    this.retrieveServiceCenterLocation(id);
  };

  render() {
    const isMobile =
      Math.min(window.screen.width, window.screen.height) < 768 ||
      navigator.userAgent.indexOf("Mobi") > -1;

    // Remove client-side filtering since API handles it
    const filterServiceCenter = this.state.serviceCenters;

    const tableHead = [
      {
        id: "name",
        label: "Name",
        width: "200px",
        valueDisplay: (value) => value || "",
      },
      {
        id: "contact_number",
        label: "Phone Number",
        width: "250px",
        valueDisplay: (value) => value || "",
      },
      {
        id: "email",
        label: "Email",
        width: "250px",
        valueDisplay: (value) => value || "email empty",
      },
      {
        id: "ticket_count",
        label: "Ticket Count",
        valueDisplay: (value) => value || "",
      },
      {
        id: "staff",
        label: "Staff Count",
        valueDisplay: (value) => value || "",
      },
      {
        id: "action",
        label: "Action",
        valueDisplay: (value) => value || "",
      },
    ];

    return (
      <div className={"page"}>
        {this.state.loading && <LoadingPage />}
        <div className="row">
          <div className="d-flex justify-content-between mb-3">
            <div
              style={{
                width: "180px",
                borderBottom: "1px solid black",
                textAlign: "center",
              }}
            >
              <h5>Service Centers</h5>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <div className="input-group col-3 pr-0">
              <input
                type="text"
                placeholder="Search Service Center Location..."
                id={"searchInput"}
                className={"form-control"}
                onChange={this.filterChange}
                onKeyPress={this.handleSearchKeyPress}
                value={this.state.searchInput}
              />
              <div
                className="input-group-prepend"
                onClick={this.handleSearchClick}
              >
                <span className="form-control ">
                  <i className="fa fa-search form-control-icon"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-4">
            <div className="row my-2">
              <div className="col-8">Service Center</div>
              <div className="col text-end">
                <button
                  disabled={this.props.userInfo.user.role !== "Admin"}
                  className="btn btn-outline-primary  btn-sm "
                  onClick={() =>
                    this.setState({
                      seller: null,
                      newSeller: null,
                      openServiceCenterCentralAdd: true,
                      showSeller: true,
                      isAdd: true,
                      serviceCenterCentralName: "",
                      statusFlow: "",
                      returnLabelLink: "",
                      country: "",
                      serviceCenterCentralBrandId:
                        this.getBrandIdForCountry(""),
                    })
                  }
                >
                  Add New
                </button>
              </div>
            </div>

            <TableContainer component={Paper}>
              <Table
                aria-labelledby="tableTitle"
                size={"small"}
                aria-label="enhanced table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: 170 }}>Service Center</TableCell>
                    <TableCell style={{ width: 70 }}>Country</TableCell>
                    <TableCell className="text-end"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.serviceCenterCentrals?.length > 0 ? (
                    this.state.serviceCenterCentrals
                      ?.filter((s) => !s.name.includes("PTC"))
                      .map((s, i) => {
                        return (
                          <TableRow
                            key={i}
                            className={
                              this.state.serviceCenterCentralId === s.id
                                ? "font-weight-bold bg-light"
                                : ""
                            }
                          >
                            <TableCell
                              style={{
                                wordWrap: "break-word",
                                cursor: "pointer",
                              }}
                              onClick={() => this.handleSellerClick(s.id)}
                            >
                              {s.name}
                            </TableCell>
                            <TableCell
                              style={{
                                wordWrap: "break-word",
                                cursor: "pointer",
                              }}
                              onClick={() => this.handleSellerClick(s.id)}
                            >
                              {s.country}
                            </TableCell>
                            <TableCell
                              style={{
                                width: "120px",
                                wordWrap: "break-word",
                              }}
                            >
                              <div className="flex justify-stretch">
                                <button
                                  disabled={
                                    this.props.userInfo.user.role !== "Admin"
                                  }
                                  className={
                                    "btn btn-outline-primary btn-sm m-1"
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.handleEditServiceCenterCentralClick(s);
                                  }}
                                >
                                  Edit
                                </button>
                                <button
                                  disabled={
                                    this.props.userInfo.user.role !== "Admin"
                                  }
                                  className={
                                    "btn btn-outline-danger btn-sm m-1"
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({
                                      showDeleteModal: true,
                                      serviceCenterCentralName: s.name,
                                      serviceCenterCentralId: s.id,
                                      country: s.country,
                                    });
                                  }}
                                >
                                  Delete
                                </button>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        No service centers available.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={this.state.centralTotalCount}
                rowsPerPage={this.state.centralLimit}
                page={this.state.centralPage - 1}
                onPageChange={this.handleCentralPageChange}
                onRowsPerPageChange={this.handleCentralLimitChange}
                sx={{
                  borderTop: "1px solid rgba(224, 224, 224, 1)",
                  ".MuiTablePagination-toolbar": {
                    minHeight: "52px",
                  },
                  ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                    {
                      margin: "0",
                    },
                }}
              />
            </TableContainer>
          </div>

          <div className={"pageContent clearfix col-8"}>
            <div className="row my-2">
              <div className="col-10">
                Locations
                {/* {this.state.searchFilter && (
                  <span className="ms-2 text-muted">
                    (Searching: "{this.state.searchFilter}")
                  </span>
                )} */}
              </div>
              <div className="col text-end">
                <button
                  disabled={this.props.userInfo.user.role !== "Admin"}
                  title="Add Service Center"
                  className="btn btn-outline-primary btn-sm "
                  onClick={this.handleAddServiceCenter}
                >
                  Add New
                </button>
              </div>
            </div>

            <div className={"admin-table-container card"}>
              <TableServiceCenter
                head={tableHead}
                data={filterServiceCenter}
                handleRetriveServiceCenterList={() =>
                  this.retrieveServiceCenterLocation(
                    this.state.serviceCenterCentralId,
                  )
                }
                protectedFetch={this.props.protectedFetch}
                serviceCenterCentralId={this.state.serviceCenterCentralId}
                userInfo={this.props.userInfo}
                // Pagination props
                page={this.state.page}
                limit={this.state.limit}
                totalCount={this.state.totalCount}
                onPageChange={this.handlePageChange}
                onLimitChange={this.handleLimitChange}
                serviceCenterId={this.state.serviceCenterId}
                selectedBrandId={this.props.selectedbrandID}
              />
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.openServiceCenterAdd}
          // onRequestClose={() => this.setState({ openServiceCenterAdd: false })}
          contentLabel={"Add New Device."}
          // style={customStyles}
          className={isMobile ? "input-modal-mobi" : "input-modal"}
        >
          <button
            onClick={() => this.setState({ openServiceCenterAdd: false })}
            className={"info-modal-close"}
          >
            <MdClose />
          </button>

          <ServiceCenterAdd
            protectedFetch={this.props.protectedFetch}
            handleCloseModal={() =>
              this.setState({ openServiceCenterAdd: false })
            }
            handleRetriveServiceCenterList={() =>
              this.retrieveServiceCenterLocation(
                this.state.serviceCenterCentralId,
              )
            }
            serviceCenterCentralId={this.state.serviceCenterCentralId}
            serviceCenterId={this.state.serviceCenterId}
            selectedBrandId={this.props.selectedbrandID}
          />
        </Modal>

        <Modal
          isOpen={this.state.openServiceCenterCentralAdd}
          // onRequestClose={() => this.setState({ openServiceCenterAdd: false })}
          contentLabel={"Add New Service Center."}
          // style={customStyles}
          className={isMobile ? "input-modal-mobi" : "input-modal"}
        >
          <button
            onClick={() =>
              this.setState({ openServiceCenterCentralAdd: false })
            }
            className={"info-modal-close"}
          >
            <MdClose />
          </button>
          <div className="card">
            <div className="card-header">Service Center</div>
            <div className="card-body">
              <div className="mb-3">
                <label className={"single-warranty-details-label"}>Name*</label>
                <input
                  type="text"
                  id="serviceCenterCentralName"
                  //  pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                  className="form-control"
                  onChange={this.handleChange}
                  required
                  value={this.state.serviceCenterCentralName}
                />
              </div>
              <div className={"mb-3"}>
                <label
                  className={"single-warranty-details-label"}
                  htmlFor="shippingVendor"
                >
                  Ticket Status Flow Type
                </label>
                <Select
                  id={"statussFlow"}
                  data-testid="assign-to-select"
                  value={statusFlowOptions.find(
                    (x) => x.value === this.state.statusFlow,
                  )}
                  options={statusFlowOptions}
                  onChange={(obj) => {
                    this.setState({ statusFlow: obj.value });
                  }}
                />{" "}
                <div style={{ color: "red" }}>
                  {this.state.errorNotification}
                </div>
              </div>
              {this.state.statusFlow === "send_link" && (
                <div className="mb-3">
                  <label className={"single-warranty-details-label"}>
                    Return Label Link
                  </label>
                  <input
                    type="text"
                    id="returnLabelLink"
                    //  pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                    className="form-control"
                    onChange={this.handleChange}
                    required
                    value={this.state.returnLabelLink}
                  />
                </div>
              )}
              <div className="mb-3">
                <label className={"single-warranty-details-label"}>
                  Country
                </label>
                <Select
                  id={"deviceId"}
                  data-testid="assign-to-select"
                  value={countryOptions.find(
                    (x) => x.value === this.state.country,
                  )}
                  options={countryOptions}
                  onChange={(obj) => {
                    this.setState({
                      country: obj.value,
                      serviceCenterCentralBrandId: this.getBrandIdForCountry(
                        obj.value,
                      ),
                    });
                  }}
                />{" "}
              </div>
            </div>
            <div className="card-footer">
              <button
                className="k-btn k-btn-outline-primary mr-3"
                onClick={() => {
                  // this.setState({ openServiceCenterCentralAdd: false });
                  if (this.state.isAdd) {
                    this.addServiceCenterCentral();
                  } else this.updateServiceCenterCentral();
                }}
              >
                Save
              </button>
              <button
                className="k-btn k-btn-outline-primary"
                onClick={() =>
                  this.setState({ openServiceCenterCentralAdd: false })
                }
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showDeleteModal}
          // onRequestClose={() => this.setState({ openServiceCenterAdd: false })}
          contentLabel={"Add New Service Center."}
          // style={customStyles}
          className={isMobile ? "input-modal-mobi" : "input-modal"}
        >
          <button
            onClick={() => this.setState({ showDeleteModal: false })}
            className={"info-modal-close"}
          >
            <MdClose />
          </button>
          <div className="card">
            <div className="card-header">Service Center</div>
            <div className="card-body">
              <div className="mb-3">
                <label className={"single-warranty-details-label"}>
                  Do you realy want to delete{" "}
                  {this.state.serviceCenterCentralName}
                </label>
              </div>
            </div>
            <div className="card-footer">
              <button
                className="k-btn k-btn-outline-primary mr-3"
                onClick={() => {
                  // this.setState({ openServiceCenterCentralAdd: false });
                  this.deleteServiceCenterCentral();
                }}
              >
                Delete
              </button>
              <button
                className="k-btn k-btn-outline-primary"
                onClick={() => this.setState({ showDeleteModal: false })}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
